/* Penoblo Preis-Range-Slider (PLP). Ersetzt die zwei Zahlen-Eingabefelder durch
   einen Doppel-Schieber. Arbeitet in EURO (Hauptwährungseinheit). Wichtig: Shopify
   liefert die Filter-Cent-Werte (range_min, range_max, min_value.value) in CENT;
   die Liquid-Seite rechnet bereits auf Euro um (divided_by 100), dieses Element
   rechnet NICHT noch einmal.
   Die zwei sichtbaren <input type=range> sind reine UI (kein name); die echten
   Filterwerte stehen in zwei Hidden-Inputs (name=...price.gte/lte) in EURO. Leerer
   Wert = keine Grenze (hält die URL sauber und ist Shopify-konform). Der native
   change-Event der Range-Inputs blubbert ans Formular -> der bestehende
   PLP-Auto-Submit (Desktop) bzw. „Ergebnisse anzeigen" (Mobil) greift unverändert. */
class PnbPriceRange extends HTMLElement {
  connectedCallback() {
    this.floor = parseInt(this.dataset.floor, 10);
    this.ceil = parseInt(this.dataset.ceil, 10);
    this.symbol = this.dataset.symbol || '';
    this.lo = this.querySelector('[data-lo]');
    this.hi = this.querySelector('[data-hi]');
    this.fill = this.querySelector('[data-fill]');
    this.loLabel = this.querySelector('[data-lo-label]');
    this.hiLabel = this.querySelector('[data-hi-label]');
    this.loInput = this.querySelector('[data-lo-input]');
    this.hiInput = this.querySelector('[data-hi-input]');
    if (!this.lo || !this.hi || isNaN(this.floor) || isNaN(this.ceil)) return;

    const signal = (this._ac = new AbortController()).signal;
    this.lo.addEventListener('input', () => this.onInput('lo'), { signal });
    this.hi.addEventListener('input', () => this.onInput('hi'), { signal });
    this.render();
  }

  disconnectedCallback() {
    if (this._ac) this._ac.abort();
  }

  onInput(which) {
    let lo = parseInt(this.lo.value, 10);
    let hi = parseInt(this.hi.value, 10);
    // Daumen dürfen sich nicht kreuzen
    if (lo > hi) {
      if (which === 'lo') { lo = hi; this.lo.value = lo; }
      else { hi = lo; this.hi.value = hi; }
    }
    this.render();
    // Hidden-Inputs in Euro spiegeln; Randwert = leer (keine Grenze)
    if (this.loInput) this.loInput.value = lo > this.floor ? lo : '';
    if (this.hiInput) this.hiInput.value = hi < this.ceil ? hi : '';
  }

  render() {
    const lo = parseInt(this.lo.value, 10);
    const hi = parseInt(this.hi.value, 10);
    const span = this.ceil - this.floor || 1;
    const loPct = ((lo - this.floor) / span) * 100;
    const hiPct = ((hi - this.floor) / span) * 100;
    if (this.fill) {
      this.fill.style.left = loPct + '%';
      this.fill.style.right = 100 - hiPct + '%';
    }
    // oberer Daumen bekommt Vorrang, wenn beide am Maximum kleben (sonst Lock)
    this.lo.style.zIndex = lo >= this.ceil ? '4' : '3';
    if (this.loLabel) this.loLabel.textContent = lo + ' ' + this.symbol;
    if (this.hiLabel) this.hiLabel.textContent = hi + ' ' + this.symbol;
  }
}

if (!customElements.get('pnb-price-range')) {
  customElements.define('pnb-price-range', PnbPriceRange);
}
